import { Image } from '../typings/index';

declare global {
  interface Document {
    documentMode?: any;
  }
}

const isIE = () => (
  !!window.MSInputMethodContext && !!document.documentMode
);

// Insert url param
const insertUrlParam = (key: string, value: string, includeHash?: boolean) => {
  // @ts-ignore
  if (history.pushState) {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    let newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${searchParams.toString()}`;
    if (includeHash && window.location.hash) {
      newurl = `${newurl}${window.location.hash}`;
    }
    window.history.pushState({ path: newurl }, '', newurl);
  }
};

// Removes all query string entires
const removeAllQueryStrings = () => {
  const url = window.location.href.replace(/(\?.*)|(@.*)/g, '');
  window.history.pushState({ path: url }, '', url);
};

// Get All url params
const getAllUrlParams = (search: string) => {
  const hashes = search.slice(search.indexOf('?') + 1).split('&');
  const params: { [key: string]: string } = {};
  hashes.map((hash) => {
    const [key, val] = hash.split('=');
    params[key] = decodeURIComponent(val);
    return true;
  });
  return params;
};

// Get param value
const getUrlParamValue = (key: any) => {
  const search = Object.entries(getAllUrlParams(window.location.href)).filter((param) => (
    param[0] === key
  ));
  return search[0] ? search[0][1] : null;
};

// Script exists in head of document.
// Taken from: https://github.com/kaimallea/isMobile
const isMobile = () => (
  /Mobi/.test(navigator.userAgent)
);

const scrollIntoView = (elemToScrollTo: HTMLElement, behaviour: ScrollBehavior) => {
  if (!isIE()) {
    elemToScrollTo.scrollIntoView({
      behavior: behaviour,
    });
  }
};

const isPortrait = (image: Image) => (
  // @ts-ignore
  (image.file.details.image.height > image.file.details.image.width)
);

const elementInViewport = (el: any) => {
  let top = el.offsetTop;
  let left = el.offsetLeft;
  const width = el.offsetWidth;
  const height = el.offsetHeight;

  while (el.offsetParent) {
    // eslint-disable-next-line no-param-reassign
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top >= window.pageYOffset
    && left >= window.pageXOffset
    && (top + height) <= (window.pageYOffset + window.innerHeight)
    && (left + width) <= (window.pageXOffset + window.innerWidth)
  );
};

const toDataURL = (url: string, callback: Function) => {
  const xhr = new XMLHttpRequest();
  xhr.onload = () => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (callback) {
        callback(reader.result);
      }
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
};

export {
  insertUrlParam,
  getAllUrlParams,
  getUrlParamValue,
  removeAllQueryStrings,
  isMobile,
  scrollIntoView,
  isPortrait,
  elementInViewport,
  toDataURL,
};
